// @ts-nocheck

import { createSelector } from 'reselect';

import { selectBasketError } from '../../selectors/basket/basketPrimary.selector';
import { selectBasketShowResume } from '../../selectors/basketCommon.selector';
import { selectBasketIsSummaryKeyboardVisible } from '../../selectors/basketCommon.selector';

const selectBasketMobileModalProps = createSelector(
  [selectBasketIsSummaryKeyboardVisible, selectBasketShowResume, selectBasketError],
  (isKeyboardVisible, showResume, basketError) => {
    const shouldScrollTop = showResume || !!basketError;
    const shouldEmptyBasketOnClosing = showResume;
    return { isKeyboardVisible, shouldScrollTop, shouldEmptyBasketOnClosing };
  },
);

export default selectBasketMobileModalProps;
